export enum ExactModelKeys {
  model = 'Model',
  maxFlow = 'Nominal Flow',
  netWeight = 'Net Weight',
  height = 'Height',
  depth = 'Depth',
  width = 'Width',
  airConnection = 'Air Connection',
  coolingMedia = 'Cooling Media',
  nominalConsumption = 'Nominal Consumption',
  nominalCurrent = 'Nominal Current',
  fullLoadCurrent = 'Full Load Current',
  lockedRotorCurrent = 'Locked Rotor Current',
  dryerType = 'Dryer Type',
  dryerCategory = 'Dryer Category',
  dryerGroup = 'Dryer Group',
  purgeFlow = 'Purge Flow',
  outletAirFlow = 'Outlet Air Flow',
}
